import { Box } from '@ui-lib';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import * as styles from './Panels.css';

export const LeftPanel = ({ children }: { children: ReactNode }): JSX.Element => (
  <Box className={styles.LeftPanel} display="flex" flexDirection="column" width="full" background="body">
    {children}
  </Box>
);

export const RightPanel = ({
  children,
  fullContentWidth = false,
}: {
  children: ReactNode;
  fullContentWidth?: boolean;
}): JSX.Element => (
  <Box
    className={styles.RightPanel}
    alignItems="center"
    justifyContent="center"
    overflow="hidden"
    width="full"
    display={{
      desktop: 'flex',
      tablet: 'none',
      mobile: 'none',
    }}
  >
    <div className={classNames(styles.RightPanelContent, fullContentWidth && styles.FullContentWidth)}>
      {children}
    </div>
  </Box>
);
